var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_core.js
// module id = 10
// module chunks = 62